import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új orvosi sablon',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }],
        
        headerFields: [
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "doctorId",
                label: "Orvos",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "text",
                label: "Szöveg",
                visibility: false,
                formType: "textarea",
                formVisible: true,
                formSize: 12,
                formRequired:true,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
